import { RouteComponentProps } from 'react-router';
import { withTranslation, WithTranslation } from 'react-i18next';
import {
  DiscountRuleDeskModel,
  discountRuleEditRoles,
  DiscountRuleModel,
  DiscountRuleProductModel
} from '../../../../api/pricing/pricing.types';
import { BrokerRateModel, CarClassModel, DeskModel, ProductModel } from '../../../../api/core/core.types';
import { UserModel } from '../../../../api/authentication/authentication.types';
import React, { FormEvent } from 'react';
import { AppState } from '../../../../store/store.types';
import { ThunkDispatch } from 'redux-thunk';
import { getDeskList } from '../../../setup/actions/desk.actions';
import { getBrokerList } from '../../../admin/actions/broker.actions';
import { getProductList } from '../../../setup/actions/product.actions';
import { connect } from 'react-redux';
import {
  addNewDiscountRule,
  deleteDiscountRule,
  editDiscountRule,
  getDiscountRule
} from '../../actions/discountrule.actions';
import { getBrokerRateList } from '../../../setup/actions/brokerrate.actions';
import Breadcrumbs from '../../../../components/breadcrumbs/Breadcrumbs';
import ConfirmationModal from '../../../../components/modals/ConfirmationModal';
import { FieldControl, FieldGroup, FormBuilder, Validators } from 'react-reactive-form';
import { TwoColumnsSelectValueModel } from '../../../../components/forms/TwoColumnsSelect';
import CalendarDateRangePicker, { DateRangeInputNew } from '../../../../components/forms/CalendarDateRangePicker';
import { dateOrderCorrect, formatDateTime } from '../../../../helpers/date.helper';
import { DATE_FORMAT, StatusType } from '../../../../api/api.types';
import dayjs from 'dayjs';
import { userCanAccessComponent } from '../../../../helpers/authentication.helper';
import SectionTitle from '../../../../components/forms/SectionTitle';
import StatusLabel from '../../../../components/forms/StatusLabel';
import { DiscountRuleActionTypes } from '../../types/discountrule.types';
import { UncontrolledTooltip as Tooltip } from 'reactstrap';
import infoIcon from '../../../../assets/img/info-circle.svg';
import { getAllCarClasses } from '../../../core/actions/carClass.actions';
import { BrokerModel, SupplierBrokerModel, SupplierModel } from '../../../../api/admin/admin.types';
import {
  getBrokerRates,
  getBrokers,
  getCarClassesList,
  getLocationsList,
  getProducts
} from '../../../../helpers/listview.helper';
import { TextInput } from '../../../../components/forms/Input';
import Checkbox from '../../../../components/forms/Checkbox';
import RadioButton from '../../../../components/forms/RadioButton';
import { MultiSelect } from '../../../../components/forms/MultiSelect';
import { Link } from 'react-router-dom';

interface DiscountRuleLocationProps {
  id: string;
}

interface DiscountRuleDetailsProps extends RouteComponentProps<DiscountRuleLocationProps>, WithTranslation {
  selectedDiscountRule: DiscountRuleModel | null;
  getSelectedDiscountRule: (id: number) => Promise<any>;
  editDiscountRule: (id: number, request: DiscountRuleModel) => void;
  addNewDiscountRule: (request: DiscountRuleModel) => void;
  deletedDiscountRule: (id: number) => void;
  getAllCarClasses: () => void;
  getDeskList: () => void;
  getBrokerList: () => void;
  getBrokerRateList: () => void;
  getProductList: () => void;
  isNew?: boolean;
  postSuccess: boolean | null;
  carClasses: CarClassModel[];
  desks: DeskModel[];
  brokers: SupplierBrokerModel[];
  brokerRates: BrokerRateModel[];
  products: ProductModel[];
  lastFetch: number | null;
  user: UserModel | null;
  supplier: SupplierModel | null;
}

interface DiscountRuleDetailsState {
  isModalOpen: boolean;
  isEdit: boolean;
  selectedDesks: string[];
  selectedCarClasses: string[];
  selectedProducts: string[];
  selectedBrokers: number[];
  selectedBrokerRates: string[];
}

class DiscountRuleDetails extends React.Component<DiscountRuleDetailsProps, DiscountRuleDetailsState> {

  readonly state = {
    isModalOpen: false,
    isEdit: false,
    selectedDesks: [],
    selectedCarClasses: [],
    selectedProducts: [],
    selectedBrokers: [],
    selectedBrokerRates: []
  };

  form = FormBuilder.group({
    id: [ null ],
    pickupFrom: [ null, Validators.required ],
    pickupTo: [ null, Validators.required ],
    requestFrom: [ null, Validators.required ],
    requestTo: [ null, Validators.required ],
    discountPercentage: [ null, [ Validators.required, Validators.min(0), Validators.max(100) ] ],
    daysFrom: [ null, [ Validators.required, Validators.min(1) ] ],
    daysTo: [ null, [ Validators.required, Validators.min(1) ] ],
    locationsSelection: [ 'all' ],
    carClassSelection: [ 'all' ],
    brokerSelection: [ 'all' ],
    brokerRateSelection: [ 'all' ],
    productSelection: [ 'all' ],
    locations: [ { items: [], selected: [] } ],
    carClasses: [ { items: [], selected: [] } ],
    brokers: [ { items: [], selected: [] } ],
    products: [ { items: [], selected: [] } ],
    brokerRates: [ { items: [], selected: [] } ],
    active: [ true ]
  });

  async componentDidMount() {
    if (!this.props.carClasses.length) {
      this.props.getAllCarClasses();
    }
    if (!this.props.products.length) {
      this.props.getProductList();
    }
    if (!this.props.desks.length) {
      this.props.getDeskList();
    }
    if (!this.props.brokers.length) {
      this.props.getBrokerList();
    }

    if (!this.props.brokerRates.length) {
      this.props.getBrokerRateList();
    }

    const { id } = this.props.match.params;
    if (id) {
      this.props.getSelectedDiscountRule(Number(id));
    }
    if (this.props.carClasses.length) {
      this.assignCarClassesToForm(this.props.carClasses);
    }

    if (this.props.desks.length) {
      this.assignDesksToForm(this.props.desks);
    }
    if (this.props.brokers.length) {
      this.assignBrokersToFrom(this.props.brokers);
    }
    if (this.props.products.length) {
      this.assignProductsToForm(this.props.products);
    }

    if (this.props.brokerRates.length) {
      this.assignBrokerRatesToForm(this.props.brokerRates);
    }


  }

  componentDidUpdate(prevProps: DiscountRuleDetailsProps) {
    if ((this.props.isNew) && this.props.postSuccess && this.props.selectedDiscountRule) {
      this.props.history.push(`/rates/discountrules/${this.props.selectedDiscountRule.id}/view`);
    }
    if (this.props.selectedDiscountRule && (!prevProps.selectedDiscountRule || this.props.selectedDiscountRule !== prevProps.selectedDiscountRule)) {
      this.updateFormValue();
    }
    if (this.props.carClasses.length !== prevProps.carClasses.length) {
      this.assignCarClassesToForm(this.props.carClasses);
    }
    if (this.props.desks.length !== prevProps.desks.length) {
      this.assignDesksToForm(this.props.desks);
    }
    if (this.props.brokers.length !== prevProps.brokers.length) {
      this.assignBrokersToFrom(this.props.brokers);
    }
    if (this.props.products.length !== prevProps.products.length) {
      this.assignProductsToForm(this.props.products);
    }
    if (this.props.brokerRates.length !== prevProps.brokerRates.length) {
      this.assignBrokerRatesToForm(this.props.brokerRates);
    }

    if (this.props.supplier) {
      if (!this.props.selectedDiscountRule?.daysTo) {
        this.form.patchValue({ daysFrom: 1, daysTo: this.props.supplier?.maxRentalDuration });
      }
    }
  }

  assignDesksToForm = (desks: DeskModel[]) => {
    const prev = this.form.controls.locations.value as TwoColumnsSelectValueModel;
    desks.forEach((desk) => {
      prev.items.push({
        name: desk.name,
        sortName: desk.name,
        id: desk.id,
        deskCode: desk.code
      });
    });
    if (this.props.selectedDiscountRule) {
      this.props.selectedDiscountRule.desks.forEach((d) => {
        prev.selected.push(d.code);
      });
      this.setState({ selectedDesks: this.props.selectedDiscountRule.desks.map((d) => d.code) });
    }
    this.form.controls.locations.setValue(prev);
  };


  updateFormValue = () => {
    if (!this.props.selectedDiscountRule) {
      return;
    }
    this.form.patchValue({
      id: this.props.selectedDiscountRule.id,
      pickupFrom: dayjs(this.props.selectedDiscountRule.pickupFrom),
      pickupTo: dayjs(this.props.selectedDiscountRule.pickupTo),
      requestFrom: dayjs(this.props.selectedDiscountRule.requestFrom),
      requestTo: dayjs(this.props.selectedDiscountRule.requestTo),
      locationsSelection: this.props.selectedDiscountRule.desks.length ? 'selection' : 'all',
      carClassSelection: this.props.selectedDiscountRule.carClasses.length ? 'selection' : 'all',
      brokerSelection: this.props.selectedDiscountRule.brokers.length ? 'selection' : 'all',
      productSelection: this.props.selectedDiscountRule.products.length ? 'selection' : 'all',
      brokerRateSelection: this.props.selectedDiscountRule.brokerRates.length ? 'selection' : 'all',
      locations: this.props.selectedDiscountRule ? {
        ...this.form.controls.locations.value,
        selected: this.props.selectedDiscountRule.desks.map((d) => d.code)
      } : this.form.controls.locations.value,
      carClasses: this.props.selectedDiscountRule ? {
        ...this.form.controls.carClasses.value,
        selected: this.props.selectedDiscountRule.carClasses.map((c) => c.acrissCode)
      } : this.form.controls.carClasses.value,
      brokers: this.props.selectedDiscountRule ? {
        ...this.form.controls.brokers.value,
        selected: this.props.selectedDiscountRule.brokers.map((b) => b.id)
      } : this.form.controls.brokers.value,
      products: this.props.selectedDiscountRule ? {
        ...this.form.controls.products.value,
        selected: this.props.selectedDiscountRule.products.map((p) => p.code)
      } : this.form.controls.products.value,
      brokerRates: this.props.selectedDiscountRule ? {
        ...this.form.controls.brokerRates.value,
        selected: this.props.selectedDiscountRule.brokerRates.map((p) => p.code)
      } : this.form.controls.brokerRates.value,
      discountPercentage: this.props.selectedDiscountRule.discountPercentage * 100,
      active: this.props.selectedDiscountRule.statusType === StatusType.ACTIVE,
      daysFrom: this.props.selectedDiscountRule.daysFrom ? this.props.selectedDiscountRule.daysFrom : 1,
      daysTo: this.props.selectedDiscountRule.daysTo
    });

    this.setState({
      selectedCarClasses: this.props.selectedDiscountRule.carClasses.map((c) => c.acrissCode),
      selectedDesks: this.props.selectedDiscountRule.desks.map((c) => c.code),
      selectedBrokers: this.props.selectedDiscountRule.brokers.map((b) => b.id),
      selectedProducts: this.props.selectedDiscountRule.products.map((p) => p.code),
      selectedBrokerRates: this.props.selectedDiscountRule.brokerRates.map((p) => p.code)
    });
  };

  assignCarClassesToForm = (carClasses: CarClassModel[]) => {
    const prev = this.form.controls.carClasses.value as TwoColumnsSelectValueModel;
    const uniqueCarClasses = [];
    const seen = new Set();
    for (const item of carClasses) {
      if (!seen.has(item.acrissCode)) {
        seen.add(item.acrissCode);
        uniqueCarClasses.push(item);
      }
    }
    prev.items = uniqueCarClasses;
    if (this.props.selectedDiscountRule) {
      this.props.selectedDiscountRule.carClasses.forEach((c) => {
        prev.selected.push(c.acrissCode);
      });
      this.setState({
        selectedCarClasses: this.props.selectedDiscountRule.carClasses
          .map((c) => c.acrissCode)
      });
    }
  };

  assignBrokersToFrom = (brokers: SupplierBrokerModel[]) => {
    const form = this.form.controls.brokers.value as TwoColumnsSelectValueModel;
    brokers.forEach((broker) => {
      const obj: any = { ...broker };
      obj.brokerId = broker.id;
      form.items.push(obj);
    });

    if (this.props.selectedDiscountRule) {
      form.selected = this.props.selectedDiscountRule.brokers.map((b) => b.id);
      this.setState({
        selectedBrokers: this.props.selectedDiscountRule.brokers.map((b) => b.id)
      });
    }
  };

  assignBrokerRatesToForm = (brokerRate: BrokerRateModel[]) => {
    const form = this.form.controls.brokerRates.value as TwoColumnsSelectValueModel;
    brokerRate.forEach((p) => {
      const obj: any = { ...p };
      obj.brokerRateCode = p.code;
      form.items.push(obj);
    });

    if (this.props.selectedDiscountRule) {
      form.selected = this.props.selectedDiscountRule.brokerRates.map((p) => p.code);
      this.setState({
        selectedBrokerRates: this.props.selectedDiscountRule.brokerRates.map((p) => p.code)
      });
    }
  };

  assignProductsToForm = (products: ProductModel[]) => {
    const form = this.form.controls.products.value as TwoColumnsSelectValueModel;
    products.forEach((p) => {
      const obj: any = { ...p };
      obj.productCode = p.code;
      form.items.push(obj);
    });

    if (this.props.selectedDiscountRule) {
      form.selected = this.props.selectedDiscountRule.products.map((p) => p.code);
      this.setState({
        selectedProducts: this.props.selectedDiscountRule.products.map((p) => p.code)
      });
    }
  };


  onDeleteConfirm = () => {
    const { id } = this.props.match.params;
    this.props.deletedDiscountRule(Number(id));
    this.props.history.push('/rates/discountrules');
  };


  onAllCarClassesSelect = () => {
    this.form.controls.carClasses.setValue({ ...this.form.controls.carClasses.value, selected: [] });
    this.setState({ selectedCarClasses: [] });
  };

  onAllLocationsSelect = () => {
    this.form.controls.locations.setValue({ ...this.form.controls.locations.value, selected: [] });
    this.setState({ selectedDesks: [] });
  };

  onAllProductsSelected = () => {
    this.form.controls.products.setValue({ ...this.form.controls.products.value, selected: [] });
    this.setState({ selectedProducts: [] });
  };

  onAllBrokersSelected = () => {
    this.form.controls.brokers.setValue({ ...this.form.controls.brokers.value, selected: [] });
    this.setState({ selectedBrokers: [] });
  };

  onAllBrokerRatesSelected = () => {
    this.form.controls.brokerRates.setValue({ ...this.form.controls.brokerRates.value, selected: [] });
    this.setState({ selectedBrokerRates: [] });
  };


  getProducts = (products: DiscountRuleProductModel[]) => {
    let productList;
    if (products.length === 0) {
      productList = this.props.t('v.discount_rules.all_products');
    } else {
      productList = (
        <ul className="details-list-with-columns">
          {products.map((product: DiscountRuleProductModel) => {
            const fullProduct = this.props.products.find((d) => d.code === product.code);
            return (
              <li
                key={product.code}
                className="list-link-item"
                onClick={() => fullProduct ? this.props.history.push(`/setup/products/${fullProduct.id}/view`) : null}
              >
                {
                  fullProduct && fullProduct.name || product.code
                }
              </li>
            );
          })}
        </ul>
      );
    }
    return productList;
  };

  handleLocationSelectValueChange = (v: any) => {
    this.setState({ selectedDesks: v.map((itm: any) => itm.deskCode) });
  };

  handleCarClassSelectValueChange = (v: any) => {
    this.setState({ selectedCarClasses: v.map((itm: any) => itm.acrissCode) });
  };

  handleProductValueChange = (v: any) => {
    this.setState({ selectedProducts: v.map((itm: any) => itm.code) });
  };

  handleBrokerRateValueChange = (v: any) => {
    this.setState({ selectedBrokerRates: v.map((itm: any) => itm.code) });
  };

  handleBrokerValueChange = (v: any) => {
    this.setState({ selectedBrokers: v.map((itm: any) => itm.id) });
  };

  onDateRangeChange = (range: DateRangeInputNew, field: string) => {
    dateOrderCorrect(range, field, this.form);
    this.form.patchValue({
      [ `${field}From` ]: range.startDate,
      [ `${field}To` ]: range.endDate
    });
  };


  onSubmit = (e: FormEvent) => {
    e.preventDefault();
    const form = this.form.controls;
    this.form.markAsSubmitted();
    if (this.form.invalid) {
      return;
    }
    if (!dateOrderCorrect({ startDate: form.pickupFrom.value, endDate: form.pickupTo.value }, 'pickup', this.form)) {
      return;
    }
    if (this.form.invalid) {
      return;
    }

    const request: DiscountRuleModel = {
      pickupFrom: `${form.pickupFrom.value.format(DATE_FORMAT)}`,
      pickupTo: `${form.pickupTo.value.format(DATE_FORMAT)}`,
      requestFrom: `${form.requestFrom.value.format(DATE_FORMAT)}`,
      requestTo: `${form.requestTo.value.format(DATE_FORMAT)}`,
      desks: this.state.selectedDesks.map((v: string) => ({ code: v })),
      carClasses: this.state.selectedCarClasses.map((v: string) => ({ acrissCode: v })),
      brokers: this.state.selectedBrokers.map((v: number) => ({ id: v })),
      products: this.state.selectedProducts.map((v: string) => ({ code: v })),
      brokerRates: this.state.selectedBrokerRates.map((v: string) => ({ code: v })),
      statusType: form.active.value ? StatusType.ACTIVE : StatusType.INACTIVE,
      discountPercentage: form.discountPercentage.value / 100,
      daysFrom: form.daysFrom.value,
      daysTo: form.daysTo.value
    };

    if (this.props.selectedDiscountRule) {
      const { id } = this.props.match.params;
      this.props.editDiscountRule(Number(id), request);
      this.setState({ isEdit: false });

    } else {
      this.props.addNewDiscountRule(request);
    }

  };

  onCancel = () => {
    if (this.props.isNew) {
      this.props.history.push('/rates/discountrules/');
    } else {
      this.updateFormValue();
      this.setState({ isEdit: false });
    }
  };

  onEdit = () => {
    this.setState({ isEdit: true });
  };

  getDesksList = (desks: DiscountRuleDeskModel[]) => {
    const deskList: { deskCode: string; }[] = [];
    desks.map((desk: DiscountRuleDeskModel) => deskList.push({ deskCode: desk.code }));
    return deskList;
  };

  getRentalDuration = (daysFrom: number, daysTo: number) => {
    if (daysFrom && daysTo) {
      return (
        <div className="form-control-static">
          {`${daysFrom} - ${daysTo}`}
        </div>
      );
    }
  };

  render() {
    if (!this.props.isNew && !this.props.selectedDiscountRule) {
      return null;
    }

    const showForm = this.state.isEdit || this.props.isNew;
    const { t } = this.props;
    return (
      <main>
        <Breadcrumbs
          items={
            [
              { path: '/rates', label: 'Rates' },
              { path: '/rates/discountrules', label: 'Discount rules' },
              { path: null, label: 'Discount rule Details' }
            ]
          }
        />
        <div className="page-content">
          <div className="row justify-content-end">
            <div className="col-12 d-flex align-items-center justify-content-between">
              <h1 className="mb-0">{
                this.props.isNew ?
                  t('page_title.add_new_discount_rule') :
                  t('page_title.discount_rule_details')
              }</h1>
            </div>
          </div>
          <div className="mb-2"/>
          {this.props.selectedDiscountRule && !showForm && this.props.user && (
            <div>
              {this.props.user && userCanAccessComponent(this.props.user, discountRuleEditRoles) ? (
                <SectionTitle
                  title={t('section_title.discount_rule.discount_rule').toUpperCase()}
                  showButton
                  buttonName={t('b.edit_Generic edit button').toUpperCase()}
                  showDeleteButton
                  deleteButtonName={t('b.delete_Generic delete button').toUpperCase()}
                  onDeleteClick={() => this.setState({ isModalOpen: true })}
                  onEditClick={() => this.onEdit()}
                />
              ) : (
                <SectionTitle
                  title={t('section_title.discount_rule.discount_rule').toUpperCase()}
                />
              )}
              <div className="d-flex row info-container">
                <label className="col-4 d-flex align-items-center justify-content-end">
                  {t('l.promo_code.discount')}:
                </label>
                <div
                  className="col-2 d-flex align-items-center justify-content-start">
                  {this.form.controls.discountPercentage.value}
                </div>
              </div>
              <div className="d-flex row info-container">
                <label className="col-4 d-flex align-items-center justify-content-end">
                  {t('l.discount_rule.pickup_period')}:
                </label>
                <div
                  className="col-2 d-flex align-items-center justify-content-start">
                  {this.form.controls.pickupFrom.value?.format('DD.MM.YYYY')}
                  {' - '}
                  {this.form.controls.pickupTo.value?.format('DD.MM.YYYY')}
                </div>
              </div>
              <div className="d-flex row info-container">
                <label className="col-4 d-flex align-items-center justify-content-end">
                  {t('l.discount_rule.request_period')}:
                </label>
                <div
                  className="col-2 d-flex align-items-center justify-content-start">
                  {this.form.controls.requestFrom.value?.format('DD.MM.YYYY')}
                  {' - '}
                  {this.form.controls.requestTo.value?.format('DD.MM.YYYY')}
                </div>
              </div>
              <div className="d-flex row info-container">
                <label className="col-4 d-flex align-items-center justify-content-end">
                  {t('l.discount_rule.rental_days')}
                  <img src={infoIcon} className="i-info-icon" id="lor-tooltip"/>:
                </label>
                <Tooltip
                  className="dark-tooltip"
                  modifiers={{ preventOverflow: { boundariesElement: 'window' } }}
                  placement="bottom"
                  target="lor-tooltip"
                  autohide={false}
                >
                        <pre className="dark-tooltip-text">
                          {t('comment.discount_rule.lor')}
                        </pre>
                </Tooltip>
                <div
                  className="col-2 d-flex align-items-center justify-content-start">
                  {this.getRentalDuration(this.form.controls.daysFrom.value, this.form.controls.daysTo.value)}
                </div>
              </div>
              <div className="d-flex row info-container">
                <label className="col-4 d-flex align-items-center justify-content-end">
                  {t('l.discount_rule.status')}:
                </label>
                <div className="col-6 d-flex align-items-center justify-content-start">
                  <StatusLabel status={this.props.selectedDiscountRule.statusType}/>
                </div>
              </div>
              <SectionTitle title={t('section_title.discount_rule.desks').toUpperCase()}/>
              <div className="d-flex row info-container">
                <div className="col-4"/>
                <div className="form-control-static">
                  {getLocationsList(
                    this.getDesksList(this.props.selectedDiscountRule.desks),
                    this.props.desks,
                    false,
                    this.props.history
                  )}
                </div>
              </div>
              <SectionTitle title={t('section_title.discount_rule.car_classes').toUpperCase()}/>
              <div className="d-flex row info-container">
                <div className="col-4"/>
                <div className="form-control-static">
                  {getCarClassesList(this.props.selectedDiscountRule.carClasses, this.props.carClasses, t('v.all_car_classes'), this.props.history)}
                </div>
              </div>
              <SectionTitle title={t('section_title.discount_rule.products').toUpperCase()}/>
              <div className="d-flex row info-container">
                <div className="col-4"/>
                <div className="form-control-static">
                  {getProducts(this.props.selectedDiscountRule.products, this.props.products, t('v.discount_rules.all_products'))}
                </div>
              </div>
              <SectionTitle title={t('section_title.discount_rule.brokers').toUpperCase()}/>
              <div className="d-flex row info-container">
                <div className="col-4"/>
                <div className="form-control-static">
                  {getBrokers(this.props.selectedDiscountRule.brokers, this.props.brokers, t('v.discount_rules.all_brokers'))}
                </div>
              </div>
              <SectionTitle title={t('section_title.discount_rule.brokerRates').toUpperCase()}/>
              <div className="d-flex row info-container">
                <div className="col-4"/>
                <div className="form-control-static">
                  {getBrokerRates(
                    this.props.selectedDiscountRule.brokerRates.map((promoBrokerRate) => ({ code: promoBrokerRate.code })),
                    this.props.brokerRates,
                    t('v.discount_rules.all_broker_rates'),
                    this.props.history
                  )}
                </div>
              </div>
            </div>
          )}
          {showForm && (
            <FieldGroup
              strict={false}
              control={this.form}
              render={() => (
                <form className="form-horizontal pt-1" onSubmit={(e) => this.onSubmit(e)}>
                  <SectionTitle title={t('section_title.discount_rule.discount_rule').toUpperCase()}/>
                  <div className="form-group row">
                    <div className="col-4 d-flex align-items-center justify-content-end">
                      <label className="mandatory-field">* </label>
                      <label>{t('l.promo_code.discount')}:</label>
                    </div>
                    <div className="col-1 d-flex align-items-center justify-content-start single-row-item">
                      <div className="col padding-zero">
                        <FieldControl
                          name="discountPercentage"
                          render={TextInput}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-4 d-flex align-items-center justify-content-end">
                      <label className="mandatory-field">* </label>
                      <label>{t('l.discount_rule.pickup_period')}:</label>
                    </div>
                    <div className="col-2 d-flex row-gap">
                      <div className="col padding-zero">
                        <CalendarDateRangePicker
                          isStartDateInput
                          startDate={this.form.controls.pickupFrom.value}
                          endDate={this.form.controls.pickupTo.value}
                          onChange={(val) => this.onDateRangeChange(val, 'pickup')}
                          inputStyle={{ flex: '50%' }}
                          isInvalid={this.form.controls.pickupFrom.invalid && this.form.submitted}
                          id="1"
                        />
                      </div>
                      <div className="col padding-zero">
                        <CalendarDateRangePicker
                          isStartDateInput={false}
                          startDate={this.form.controls.pickupFrom.value}
                          endDate={this.form.controls.pickupTo.value}
                          onChange={(val) => this.onDateRangeChange(val, 'pickup')}
                          inputStyle={{ flex: '50%' }}
                          isInvalid={this.form.controls.pickupTo.invalid && this.form.submitted}
                          id="2"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-4 d-flex align-items-center justify-content-end">
                      <label className="mandatory-field">* </label>
                      <label>{t('l.discount_rule.request_period')}:</label>
                    </div>
                    <div className="col-2 d-flex row-gap">
                      <div className="col padding-zero">
                        <CalendarDateRangePicker
                          isStartDateInput
                          startDate={this.form.controls.requestFrom.value}
                          endDate={this.form.controls.requestTo.value}
                          onChange={(val) => this.onDateRangeChange(val, 'request')}
                          inputStyle={{ flex: '50%' }}
                          isInvalid={this.form.controls.requestFrom.invalid && this.form.submitted}
                          id="1"
                        />
                      </div>
                      <div className="col padding-zero">
                        <CalendarDateRangePicker
                          isStartDateInput={false}
                          startDate={this.form.controls.requestFrom.value}
                          endDate={this.form.controls.requestTo.value}
                          onChange={(val) => this.onDateRangeChange(val, 'request')}
                          inputStyle={{ flex: '50%' }}
                          isInvalid={this.form.controls.requestTo.invalid && this.form.submitted}
                          id="2"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-4 d-flex align-items-center justify-content-end">
                      <label className="mandatory-field">*</label>
                      <label>{t('l.discount_rule.rental_days')}
                        <img src={infoIcon} className="i-info-icon" id="lor-tooltip"/>:</label>
                    </div>
                    <Tooltip
                      className="dark-tooltip"
                      modifiers={{ preventOverflow: { boundariesElement: 'window' } }}
                      placement="bottom"
                      target="lor-tooltip"
                      autohide={false}
                    >
                        <pre className="dark-tooltip-text">
                          {t('comment.discount_rule.lor')}
                        </pre>
                    </Tooltip>
                    <div className="col-2 d-flex row-gap">
                      <div className="col padding-zero">
                        <FieldControl
                          name="daysFrom"
                          render={TextInput}
                        />
                      </div>
                      <div className="col padding-zero">
                        <FieldControl
                          name="daysTo"
                          render={TextInput}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-4 d-flex align-items-center justify-content-end">
                      <label className="mandatory-field">* </label>
                      <label>{t('l.discount_rule.status')}:</label>
                    </div>
                    <div className="col-6 d-flex align-items-center justify-content-start">
                      <FieldControl
                        name="active"
                        render={(props) =>
                          <Checkbox {...props} id="statusField" className="mt-1">{t('text.status.active')}</Checkbox>
                        }
                      />
                    </div>
                  </div>
                  <SectionTitle title={t('section_title.discount_rule.desks').toUpperCase()}/>
                  <div className="form-group row">
                    <div className="col-4"/>
                    <div className="col-8 d-flex align-items-center justify-content-start">
                      <div className="d-flex flex-column flex-wrap">
                        <div className="pb-1">
                          <FieldControl
                            strict={false}
                            name="locationsSelection"
                            render={(props) => (
                              <RadioButton
                                {...props}
                                onClick={this.onAllLocationsSelect}
                                fieldValue="all"
                                id="loc_all"
                              >
                                {t('l.selection.all')}
                              </RadioButton>
                            )}
                          />
                          <FieldControl
                            strict={false}
                            name="locationsSelection"
                            render={(props) => (
                              <RadioButton
                                {...props}
                                fieldValue="selection"
                                id="loc_sel"
                              >
                                {t('l.selection.selected')}
                              </RadioButton>
                            )}
                          />
                        </div>
                        {
                          this.form.controls.locationsSelection.value === 'selection'
                          && (
                            <FieldControl
                              name="locations"
                              render={(v) => (
                                <MultiSelect
                                  {...v}
                                  selectedAttributeName="deskCode"
                                  sortAttributeName="name"
                                  handleValueChange={(val: any) => this.handleLocationSelectValueChange(val)}
                                  filterAttributes={[ 'name', 'deskCode' ]}
                                  primaryAtr="name"
                                  secondaryAtr="deskCode"
                                />
                              )}
                            />
                          )
                        }
                      </div>
                    </div>
                  </div>
                  <SectionTitle title={t('section_title.discount_rule.car_classes').toUpperCase()}/>
                  <div className="form-group row">
                    <div className="col-4"/>
                    <div className="col-8 d-flex align-items-center justify-content-start">
                      <div className="d-flex flex-column flex-wrap">
                        <div className="pb-1">
                          <FieldControl
                            strict={false}
                            name="carClassSelection"
                            render={(props) => (
                              <RadioButton
                                {...props}
                                onClick={this.onAllCarClassesSelect}
                                fieldValue="all"
                                id="car_all"
                              >
                                {t('l.selection.all')}
                              </RadioButton>
                            )}
                          />
                          <FieldControl
                            strict={false}
                            name="carClassSelection"
                            render={(props) => (
                              <RadioButton
                                {...props}
                                fieldValue="selection"
                                id="car_sel"
                              >
                                {t('l.selection.selected')}
                              </RadioButton>
                            )}
                          />
                        </div>
                        {
                          this.form.controls.carClassSelection.value === 'selection'
                          && (
                            <FieldControl
                              name="carClasses"
                              render={(v) => (
                                <MultiSelect
                                  {...v}
                                  selectedAttributeName="acrissCode"
                                  sortAttributeName="acrissCode"
                                  handleValueChange={(val: any) => this.handleCarClassSelectValueChange(val)}
                                  filterAttributes={[ 'acrissCode' ]}
                                  primaryAtr="acrissCode"
                                  secondaryAtr="name"
                                />
                              )}
                            />
                          )
                        }
                      </div>
                    </div>
                  </div>
                  <SectionTitle title={t('section_title.discount_rule.products').toUpperCase()}/>
                  <div className="form-group row">
                    <div className="col-4"/>
                    <div className="col-6 d-flex align-items-center justify-content-start">
                      <div className="d-flex flex-column flex-wrap">
                        <div className="pb-1">
                          <FieldControl
                            strict={false}
                            name="productSelection"
                            render={(props) => (
                              <RadioButton
                                {...props}
                                onClick={this.onAllProductsSelected}
                                fieldValue="all"
                                id="prod_all"
                              >
                                {t('l.selection.all')}
                              </RadioButton>
                            )}
                          />
                          <FieldControl
                            strict={false}
                            name="productSelection"
                            render={(props) => (
                              <RadioButton
                                {...props}
                                fieldValue="selection"
                                id="prod_sel"
                              >
                                {t('l.selection.selected')}
                              </RadioButton>
                            )}
                          />
                        </div>
                        {
                          this.form.controls.productSelection.value === 'selection'
                          && (
                            <FieldControl
                              name="products"
                              render={(v) => (
                                <MultiSelect
                                  {...v}
                                  selectedAttributeName="code"
                                  sortAttributeName="name"
                                  handleValueChange={(val: any) => this.handleProductValueChange(val)}
                                  filterAttributes={[ 'name' ]}
                                  secondaryAtr="name"
                                />
                              )}
                            />
                          )
                        }
                      </div>
                    </div>
                  </div>
                  <SectionTitle title={t('section_title.discount_rule.brokers').toUpperCase()}/>
                  <div className="form-group row">
                    <div className="col-4"/>
                    <div className="col-6 d-flex align-items-center justify-content-start">
                      <div className="d-flex flex-column flex-wrap">
                        <div className="pb-1">
                          <FieldControl
                            strict={false}
                            name="brokerSelection"
                            render={(props) => (
                              <RadioButton
                                {...props}
                                onClick={this.onAllBrokersSelected}
                                fieldValue="all"
                                id="bro_all"
                              >
                                {t('l.selection.all')}
                              </RadioButton>
                            )}
                          />
                          <FieldControl
                            strict={false}
                            name="brokerSelection"
                            render={(props) => (
                              <RadioButton
                                {...props}
                                fieldValue="selection"
                                id="bro_sel"
                              >
                                {t('l.selection.selected')}
                              </RadioButton>
                            )}
                          />
                        </div>
                        {
                          this.form.controls.brokerSelection.value === 'selection'
                          && (
                            <FieldControl
                              name="brokers"
                              render={(v) => (
                                <MultiSelect
                                  {...v}
                                  selectedAttributeName="brokerId"
                                  sortAttributeName="name"
                                  handleValueChange={(val: any) => this.handleBrokerValueChange(val)}
                                  filterAttributes={[ 'name' ]}
                                  secondaryAtr="name"
                                />
                              )}
                            />
                          )
                        }
                      </div>
                    </div>
                  </div>
                  <SectionTitle title={t('section_title.discount_rule.brokerRates').toUpperCase()}/>
                  <div className="form-group row">
                    <div className="col-4"/>
                    <div className="col-6 d-flex align-items-center justify-content-start">
                      <div className="d-flex flex-column flex-wrap">
                        <div className="pb-1">
                          <FieldControl
                            strict={false}
                            name="brokerRateSelection"
                            render={(props) => (
                              <RadioButton
                                {...props}
                                onClick={this.onAllBrokerRatesSelected}
                                fieldValue="all"
                                id="bror_all"
                              >
                                {t('l.selection.all')}
                              </RadioButton>
                            )}
                          />
                          <FieldControl
                            strict={false}
                            name="brokerRateSelection"
                            render={(props) => (
                              <RadioButton
                                {...props}
                                fieldValue="selection"
                                id="bror_sel"
                              >
                                {t('l.selection.selected')}
                              </RadioButton>
                            )}
                          />
                        </div>
                        {
                          this.form.controls.brokerRateSelection.value === 'selection'
                          && (
                            <FieldControl
                              name="brokerRates"
                              render={(v) => (
                                <MultiSelect
                                  {...v}
                                  selectedAttributeName="code"
                                  sortAttributeName="name"
                                  handleValueChange={(val: any) => this.handleBrokerRateValueChange(val)}
                                  filterAttributes={[ 'name', 'code' ]}
                                  primaryAtr="code"
                                  secondaryAtr="name"
                                />
                              )}
                            />
                          )
                        }
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 text-right">
                      <button
                        type="button"
                        className="btn btn-outline-secondary btn-lg mr-2"
                        onClick={this.onCancel}
                      >
                        {t('b.cancel_Generic cancel button translation').toUpperCase()}
                      </button>
                      <button type="submit" className="btn btn-primary btn-lg" onClick={this.onSubmit}>
                        {t('b.save_Generic save button translation').toUpperCase()}
                      </button>
                    </div>
                  </div>
                </form>
              )}
            />
          )}
          {this.props.selectedDiscountRule && !showForm && (
            <>
              <SectionTitle title={t('section_title.audit').toUpperCase()}/>
              <div className="d-flex">
                <div className="col-8">
                  <div className="d-flex row info-container">
                    <label
                      className="col-6 d-flex align-items-center justify-content-end">{t('l.car_model.created_by')}: </label>
                    <div className="col-4 d-flex align-items-center justify-content-start">
                      {this.props.selectedDiscountRule.createdBy ?? 'System'}{this.props.selectedDiscountRule.createdAt ? ` @ ${formatDateTime(this.props.selectedDiscountRule.createdAt)}` : ''}
                    </div>
                    <label
                      className="col-6 d-flex align-items-center justify-content-end">{t('l.car_model.modified_by')}: </label>
                    <div className="col-4 d-flex align-items-center justify-content-start">
                      {this.props.selectedDiscountRule.modifiedBy ?? 'System'}{this.props.selectedDiscountRule.modifiedAt ? ` @ ${formatDateTime(this.props.selectedDiscountRule.modifiedAt)}` : ''}
                    </div>
                    <label
                      className="col-6 d-flex align-items-center justify-content-end">{t('l.car_model.log')}: </label>
                    <div className="col-4 d-flex align-items-center justify-content-start">
                      <Link to={`/rates/discountrules/${this.props.selectedDiscountRule.id}/audit`}
                            className="btn btn-text-only"
                            target="_blank"
                            rel="noopener noreferrer">
                        {t('b.car_model.view_audit_log')}
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
        <ConfirmationModal
          title={t('modal_text.discount_rule.confirm_removal.title')}
          content={t('modal_text.discount_rule.confirm_removal.content')}
          isOpen={this.state.isModalOpen}
          toggle={() => this.setState({ isModalOpen: false })}
          onConfirm={() => this.onDeleteConfirm()}
          onCancel={() => this.setState({ isModalOpen: false })}
        />
      </main>);
  }
}

const mapStateToProps = (state: AppState) => ({
  selectedDiscountRule: state.rates.discountRules.selectedDiscountRule,
  postSuccess: state.rates.discountRules.postSuccess,
  carClasses: state.core.carClasses.acrissCodes,
  desks: state.setup.desks.desks,
  products: state.setup.products.products,
  brokers: state.admin.supplierBrokers.supplierBrokers,
  brokerRates: state.core.brokerRates.brokerRates,
  lastFetch: state.rates.discountRules.lastFetch,
  user: state.authentication.user,
  supplier: state.authentication.activeSupplier
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<{}, {}, DiscountRuleActionTypes>
) => ({
  getSelectedDiscountRule: (id: number) => dispatch(getDiscountRule(id)),
  editDiscountRule: (id: number, request: DiscountRuleModel) => dispatch(editDiscountRule(id, request)),
  addNewDiscountRule: (request: DiscountRuleModel) => dispatch(addNewDiscountRule(request)),
  deletedDiscountRule: (id: number) => dispatch(deleteDiscountRule(id)),
  getAllCarClasses: () => dispatch(getAllCarClasses()),
  getDeskList: () => dispatch(getDeskList()),
  getBrokerList: () => dispatch(getBrokerList()),
  getBrokerRateList: () => dispatch(getBrokerRateList()),
  getProductList: () => dispatch(getProductList())
});

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(DiscountRuleDetails));